import React, { Component } from "react";
import {
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Button,
  Modal,
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  createRoom,
  getRoomFeatureList,
  removeRoom,
  getRoomList,
  getRoomTypeList,
  getRoomHospitalityServiceList,
  getRoomById,
  updateRoom,
} from "../../Endpoint/Admin/index";
import BranchAssignment from "../../components/Common/BranchAssignment";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Panel, StatCard, StatRow, Table, Chip, Btn,
} from "../../components/Console/ConsoleUI";

import { toast } from "react-toastify";

import { AvForm, AvField } from "availity-reactstrap-validation";
import { canWrite } from "../../services/PermissionService";

/**
 * Room inventory — the "Rooms" half of console screen C2·07 (Room manager).
 *
 * A reskin of the old MDBDataTable page: the same create / update / activate
 * calls, the same image uploads and branch assignment. The table is the kit's
 * quiet table now, and selecting a row fills the preview panel beside it from
 * data already fetched — no extra request.
 */

/** Segmented pill row that navigates, matching the design's Room-types toggle. */
const NavPills = ({ items, active }) => (
  <div style={{ display: "flex", padding: 4, borderRadius: 21, background: "#efe2ce" }}>
    {items.map((i) => (
      <Link
        key={i.to}
        to={i.to}
        style={{
          padding: "8px 16px", borderRadius: 17, fontSize: 14, textDecoration: "none",
          background: i.to === active ? C.brown : "transparent",
          color: i.to === active ? "#fff" : C.taupe,
        }}
      >
        {i.label}
      </Link>
    ))}
  </div>
);

/**
 * The modal's submit control. A real <button type="submit"> so AvForm's
 * validation still fires; the kit's Btn is type="button" and would not submit.
 */
const SUBMIT_STYLE = {
  display: "inline-flex", alignItems: "center", justifyContent: "center",
  height: 42, padding: "0 22px", borderRadius: 21, fontSize: 14,
  fontFamily: "inherit", cursor: "pointer", border: "none",
  background: C.brown, color: "#fff",
};

// Optional room details the customer app shows. The number keys must be
// whole numbers (sizeSqm may be fractional); every one is optional.
const DETAIL_KEYS = [
  "description",
  "maxAdults",
  "maxChildren",
  "sizeSqm",
  "cancellationPolicy",
  "freeCancelHours",
];
const EMPTY_DETAILS = DETAIL_KEYS.reduce((acc, k) => ({ ...acc, [k]: "" }), {});
const DETAIL_NUMBERS = [
  { key: "maxAdults", label: "Max adults", integer: true },
  { key: "maxChildren", label: "Max children", integer: true },
  { key: "sizeSqm", label: "Size (m²)", integer: false },
  { key: "freeCancelHours", label: "Free cancellation hours", integer: true },
];

/** First problem with the optional number fields, or null. Blank is fine. */
const roomDetailsError = (state) => {
  for (const f of DETAIL_NUMBERS) {
    const raw = String(state[f.key] == null ? "" : state[f.key]).trim();
    if (raw === "") continue;
    const n = Number(raw);
    if (!Number.isFinite(n) || n < 0) return `${f.label} must be a number of 0 or more`;
    if (f.integer && !Number.isInteger(n)) return `${f.label} must be a whole number`;
  }
  return null;
};

/** Compact row action, the console equivalent of the old btn-primary cell. */
const RowBtn = ({ tone, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      height: 32, padding: "0 14px", borderRadius: 16, fontSize: 13,
      fontFamily: "inherit", cursor: "pointer", whiteSpace: "nowrap",
      border: tone === "solid" ? "none" : `1px solid ${C.border}`,
      background: tone === "solid" ? C.brown : "#fff",
      color: tone === "solid" ? "#fff" : C.brown,
    }}
  >
    {children}
  </button>
);

/**
 * Room thumbnail that gives up gracefully. Seeded rooms often point at images
 * that no longer exist, and a broken-image box in every row reads as a bug.
 */
class Thumb extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  render() {
    const { src, fluid, height = 44, radius = 10 } = this.props;
    const width = fluid ? "100%" : this.props.width || 54;
    const box = {
      width, height, borderRadius: radius,
      flex: fluid ? "1 1 auto" : `0 0 ${width}px`,
    };
    if (!src || this.state.failed) {
      return (
        <span
          className="ms"
          style={{
            ...box, background: C.iconTint, color: C.brown,
            display: "grid", placeItems: "center", fontSize: fluid ? 34 : 22,
          }}
        >
          bed
        </span>
      );
    }
    return (
      <img
        src={src}
        alt=""
        onError={() => this.setState({ failed: true })}
        style={{ ...box, objectFit: "cover", display: "block" }}
      />
    );
  }
}

class FormMask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidFile: false,
      roomId: "",
      items: [],
      roomtypeData: [],
      roomFeaturesData: [],
      hospitalityServicesData: [],
      isLoaded: false,
      updatemodal: false,
      modal: false,
      availability: true,
      roomName: "",
      roomType: "",
      beds: "",
      bedType: "",
      bathroomType: "",
      foodAndBeverages: "",
      kitchenFeatures: "",
      entertainment: "",
      roomFeatures: null,
      hospitalityServices: null,
      selectedFile: null,
      previewImage: [],
      invalidImage: null,
      roomFurnitureAndFurnishing: "",
      reviews: "",
      selectedFileRoom: null,
      previewImageRoom: [],
      invalidRoomImage: null,
      bath: "",
      // Optional guest-facing details. Strings so a blank input stays blank;
      // see roomDetailsError / handleSubmit for what is sent.
      ...EMPTY_DETAILS,
      branchIds: [],
      excludedBranchIds: [],
      success: {},
      // Which row the preview panel is showing. View state only.
      selectedRoomId: null,
      breadcrumbItems: [
        { title: "", link: "#" },
        { title: " ", link: "#" },
      ],
      customchk: true,
      toggleSwitch: true,
      tableData: {
        columns: [
          {
            label: "Room Name",
            field: "roomName",
            sort: "asc",
            width: 60,
          },
          {
            label: "Room Type",
            field: "roomType",
            sort: "asc",
            width: 60,
          },
          {
            label: "Beds",
            field: "beds",
            sort: "asc",
            width: 60,
          },
          {
            label: "Availability",
            field: "availability",
            sort: "asc",
            width: 60,
          },

          ...(canWrite() ? [{
            label: "Update",
            field: "update",
            sort: "asc",
            width: 100,
          }] : []),

          ...(canWrite() ? [{
            label: "Status",
            field: "remove",
            sort: "asc",
            width: 100,
          }] : []),
        ],
        rows: [],
      },
    };
    this.reader = new FileReader();
    this.handleChange = this.handleChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onRoomFileChange = this.onRoomFileChange.bind(this);
    this.ShortlistedUser = this.ShortlistedUser.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handlefeatureChange = this.handlefeatureChange.bind(this);
    this.handlehospitalityChange = this.handlehospitalityChange.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
      roomId: "",
      roomName: "",
      roomType: "",
      beds: "",
      bedType: "",
      availability: "",
      bathroomType: "",
      foodAndBeverages: "",
      kitchenFeatures: "",
      entertainment: "",
      roomFeatures: "",
      hospitalityServices: "",
      selectedFile: "",
      previewImage: "",
      reviews: "",
      selectedFileRoom: "",
      previewImageRoom: "",
      bath: "",
      invalidImage: null,
      invalidRoomImage: null,
      ...EMPTY_DETAILS,
      branchIds: [],
      excludedBranchIds: [],
    });
  }
  updatetoggle() {
    this.setState({
      updatemodal: !this.state.updatemodal,
    });
  }

  handleCloseModal() {
    this.setState({
      updatemodal: false,
      modal: false,
    });
  }

  ShortlistedUser() {
    this.setState({
      availability: !this.state.availability,
    });
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {}
    );
  };

  handlefeatureChange = (selectedOptions) => {
    // const selected = [];

    // let selectedOption = (selectedOptions);
    // for (let i = 0; i < selectedOption.length; i++) {

    //   selected.push(selectedOption[i].value)

    // }

    this.setState({
      roomFeatures: [...selectedOptions],
      // roomFeatures: selected
    });
  };

  handlehospitalityChange = (selectedOptions) => {
    console.log("selectedOptions", selectedOptions);
    // const selected = [];

    // let selectedOption = (selectedOptions);
    // for (let i = 0; i < selectedOption.length; i++) {

    //   selected.push(selectedOption[i].value)

    // }

    this.setState({
      hospitalityServices: [...selectedOptions],
      // hospitalityServices: selected
    });
  };

  onFileChange(event) {
    const imageFile = event.target.files;
    for (let i = 0; i < imageFile.length; i++) {
      if (!imageFile[i].name.match(/\.(jpg|jpeg|png)$/)) {
        this.setState({
          invalidImage: "Please select valid image.",
          previewImage: [...event.target.files].map(URL.createObjectURL),
        });
        return false;
      } else {
        this.setState({
          selectedFile: event.target.files,
          previewImage: [...event.target.files].map(URL.createObjectURL),
          invalidImage: null,
        });
      }
    }
    // this.setState({
    //   selectedFile: event.target.files,
    //   previewImage: [...event.target.files].map(URL.createObjectURL),

    // });
  }
  onRoomFileChange(event) {
    const imageFile = event.target.files;
    for (let i = 0; i < imageFile.length; i++) {
      if (!imageFile[i].name.match(/\.(jpg|jpeg|png)$/)) {
        this.setState({
          invalidRoomImage: "Please select valid image.",
          previewImageRoom: [...event.target.files].map(URL.createObjectURL),
        });
        return false;
      } else {
        this.setState({
          selectedFileRoom: event.target.files,
          previewImageRoom: [...event.target.files].map(URL.createObjectURL),
          invalidRoomImage: null,
        });
      }
    }
    // this.setState({
    //   selectedFileRoom: event.target.files,
    //   previewImageRoom:  [...event.target.files].map(URL.createObjectURL)

    // });
  }

  roomtypes() {
    getRoomTypeList()
      .then((result) => {
        this.setState({
          roomtypeData: result.data,
        });
      })
      .catch((error) => {
        console.log("error ---> ", error);
      });
  }

  RoomFeatureList() {
    getRoomFeatureList()
      .then((result) => {
        this.setState({
          roomFeaturesData: result.data,
        });
        const dropDownValues = this.state.roomFeaturesData.map((response) => ({
          value: response._id,
          label: response.featureName,
        }));
        this.setState({
          dropDownOpts: dropDownValues,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  HospitalityServiceList() {
    getRoomHospitalityServiceList()
      .then((result) => {
        this.setState({
          hospitalityServicesData: result.data,
        });
        const dropDownValue = this.state.hospitalityServicesData.map(
          (response) => ({
            value: response._id,
            label: response.hospitalityServiceName,
          })
        );
        this.setState({
          dropDownOpt: dropDownValue,
        });
      })
      .catch((error) => {});
  }
  handleSubmit(e) {
    e.preventDefault();

    const detailsError = roomDetailsError(this.state);
    if (detailsError) {
      toast.error(detailsError);
      return;
    }

    let hospitality = [];
    this.state.hospitalityServices.map((each) => {
      hospitality.push(each.value);
      return each;
    });

    let room = [];
    this.state.roomFeatures.map((each) => {
      room.push(each.value);
      return each;
    });
    console.log("In handleSubmit", hospitality);
    const formData = new FormData();
    formData.append("bath", this.state.bath);
    formData.append("roomName", this.state.roomName);
    formData.append("roomTypeId", this.state.roomType);
    formData.append("beds", this.state.beds);
    formData.append("bedType", this.state.bedType);
    formData.append("availability", this.state.availability);
    formData.append("foodAndBeverages", this.state.foodAndBeverages);
    formData.append("bathroomType", this.state.bathroomType);
    formData.append("kitchenFeatures", this.state.kitchenFeatures);
    formData.append("entertainment", this.state.entertainment);
    formData.append("roomFeatures", room);
    formData.append("hospitalityServices", hospitality);
    for (var x = 0; x < this.state.selectedFileRoom.length; x++) {
      formData.append("roomImage", this.state.selectedFileRoom[x]);
    }
    for (var i = 0; i < this.state.selectedFile.length; i++) {
      formData.append("roomFurnitureAndFurnishing", this.state.selectedFile[i]);
    }
    formData.append("roomId", this.state.roomId);
    // Always sent, trimmed: the server stores "" as null, so a field the admin
    // emptied on edit is really cleared (roomDetails() in controllers/room.js).
    DETAIL_KEYS.forEach((k) => {
      formData.append(k, String(this.state[k] == null ? "" : this.state[k]).trim());
    });
    formData.append("branchIds", JSON.stringify(this.state.branchIds || []));
    formData.append(
      "excludedBranchIds",
      JSON.stringify(this.state.excludedBranchIds || [])
    );
    console.log(this.state.roomFeatures);
    console.log(this.state.selectedFile);

    if (this.state.roomId == "" || this.state.roomId == null) {
      createRoom(formData)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                roomName: "",
                roomType: "",
                availability: false,
                beds: "",
                bedType: "",
                bathroomType: "",
                foodAndBeverages: "",
                kitchenFeatures: "",
                entertainment: "",
                roomFeatures: "",
                hospitalityServices: "",
                selectedFile: "",
                previewImage: "",
                reviews: "",
                invalidImage: "",
                invalidRoomImage: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Room  added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }
      updateRoom(formData)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "",
                roomId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Room  updated successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  removeRoom(id, isActive) {
    const data = {
      roomId: id,
      isActive: isActive,
    };
    removeRoom(data)
      .then((results) => {
        if (results.status !== 200) {
          toast.error(results.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.success("Room status changed successfully");
        }
        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      });
  }

  getALlluser() {
    getRoomList().then((result) => {
      this.setState({
        isLoaded: true,
        items: result.data,
        tableData: {
          ...this.state.tableData,
          rows: result.data,
          list: result.data.map((x) => {
            x.isActive = x.isActive === true ? false : true;
            x.update = canWrite() ? (
              <RowBtn onClick={() => this.editRoom(x._id.toString(), x)}>
                Update
              </RowBtn>
            ) : null;
            x.remove = canWrite() ? (
              <RowBtn
                onClick={() => this.removeRoom(x._id.toString(), x.isActive)}
              >
                {x.isActive === true ? "Deactive" : "Active"}
              </RowBtn>
            ) : null;

            return x;
          }),
        },
      });
    });
  }
  editRoom(id) {
    console.log(id);
    getRoomById(id)
      .then((results) => {
        console.log(results);
        let roomFeaturescopy = [];
        let hospitalityServicescopy = [];
        let copyroompreview = [];
        let copyroomfile = [];
        let copyfurniturepreview = [];
        let copyrurniturefile = [];
        for (var x = 0; x < results.data.roomImages.length; x++) {
          copyroompreview.push(results.data.roomImages[x].image);
          copyroomfile.push(results.data.roomImages[x].imageFile);
        }

        roomFeaturescopy = results.data.roomFeatures.map((response) => ({
          value: response._id,
          label: response.featureName,
        }));

        // for (let y = 0; y < results.data.roomFeatures.length; y++) {
        //   roomFeaturescopy.push(results.data.roomFeatures[y]._id)

        // }
        hospitalityServicescopy = results.data.hospitalityServices.map(
          (response) => ({
            value: response._id,
            label: response.hospitalityServiceName,
          })
        );
        // for (let k = 0; k < results.data.hospitalityServices.length; k++) {
        //   hospitalityServicescopy.push(results.data.hospitalityServices[k]._id)

        // }

        for (
          let j = 0;
          j < results.data.roomFurnitureAndFurnishing.length;
          j++
        ) {
          copyfurniturepreview.push(
            results.data.roomFurnitureAndFurnishing[j].image
          );
          copyrurniturefile.push(
            results.data.roomFurnitureAndFurnishing[j].imageFile
          );
        }

        this.setState({
          roomName: results.data.roomName,
          beds: results.data.beds,
          roomType: results.data.roomType._id,
          bedType: results.data.bedType,
          bathroomType: results.data.bathroomType,
          foodAndBeverages: results.data.foodAndBeverages,
          entertainment: results.data.entertainment,
          kitchenFeatures: results.data.kitchenFeatures,
          hospitalityServices: hospitalityServicescopy,
          availability: results.data.availability,
          // roomFeatures:roomFeaturescopy,
          bath: results.data.bath,
          selectedFile: copyrurniturefile,
          previewImage: copyfurniturepreview,
          selectedFileRoom: copyroomfile,
          previewImageRoom: copyroompreview,
          roomId: results.data._id,
          roomFeatures: roomFeaturescopy,
          // null / missing on the record = not stated -> blank input.
          ...DETAIL_KEYS.reduce((acc, k) => {
            const v = results.data[k];
            acc[k] = v == null ? "" : String(v);
            return acc;
          }, {}),
          branchIds: (results.data.branchIds || []).map((b) =>
            b && b._id ? b._id : String(b)
          ),
          excludedBranchIds: (results.data.excludedBranchIds || []).map((b) =>
            b && b._id ? b._id : String(b)
          ),
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error("error");
      });
    this.toggle();
  }

  componentDidMount() {
    this.roomtypes();
    this.getALlluser();
    this.RoomFeatureList();
    this.HospitalityServiceList();
  }

  /** roomType arrives populated, so never render it straight into a cell. */
  roomTypeName(room) {
    const t = room && room.roomType;
    if (!t) return "—";
    return typeof t === "object" ? t.type || "—" : String(t);
  }

  roomImage(room) {
    const img = room && room.roomImages && room.roomImages[0];
    return (img && (img.image || img.imageURL)) || null;
  }

  /**
   * Display columns, derived from the permission-gated column list in state so
   * the Update / Status columns still appear only for a writer.
   */
  consoleColumns() {
    const render = {
      roomName: (x) => (
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Thumb src={this.roomImage(x)} />
          <div>
            <div style={{ fontSize: 15, color: C.ink }}>{x.roomName || "—"}</div>
            <div style={{ fontSize: 12, color: C.taupeLight }}>
              {x.beds || 0} bed{x.beds === 1 ? "" : "s"} · {x.bedType || "—"}
            </div>
          </div>
        </div>
      ),
      roomType: (x) => <span style={{ color: C.taupe }}>{this.roomTypeName(x)}</span>,
      beds: (x) => <span style={{ color: C.ink }}>{x.beds || 0}</span>,
      availability: (x) =>
        x.availability ? <Chip tone="good">Bookable</Chip> : <Chip tone="warn">Unavailable</Chip>,
      update: (x) => x.update,
      remove: (x) => x.remove,
    };

    return this.state.tableData.columns.map((c) => ({
      key: c.field,
      label: c.field === "remove" ? "Activation" : c.label,
      render: render[c.field] || ((x) => x[c.field]),
    }));
  }

  render() {
    const {
      handleResponse,
      invalidImage,
      invalidRoomImage,
      items,
      previewImage,
      previewImageRoom,
    } = this.state;

    const rooms = items || [];
    const available = rooms.filter((r) => r.availability).length;
    const selected =
      rooms.find((r) => r._id === this.state.selectedRoomId) || rooms[0] || null;

    return (
      <ConsolePage
        title="Rooms"
        actions={
          <React.Fragment>
            <NavPills
              active="/Room"
              items={[
                { to: "/Room", label: "Rooms" },
                { to: "/RoomType", label: "Room types" },
                { to: "/Booking", label: "Bookings" },
                // Routed but previously linked from nowhere.
                { to: "/RoomCancel", label: "Cancellations" },
              ]}
            />
            {canWrite() && (
              <Btn icon="add" onClick={this.toggle}>
                New room
              </Btn>
            )}
          </React.Fragment>
        }
      >
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={`con-modal ${this.props.className || ""}`}
          size="lg"
          scrollable
          contentClassName="bg-transparent border-0"
        >
          <div style={{ background: "#fdf9f3", borderRadius: 22, padding: 28 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
              <span
                className="ms"
                style={{ fontSize: 24, color: C.brown, background: C.iconTint, padding: 11, borderRadius: 14 }}
              >
                bed
              </span>
              <div style={{ flex: 1, fontSize: 20, fontWeight: 500, color: C.ink }}>
                Room details
              </div>
              <span
                className="ms"
                onClick={this.toggle}
                style={{ fontSize: 22, color: C.taupeLight, cursor: "pointer" }}
              >
                close
              </span>
            </div>
            <AvForm onValidSubmit={this.handleSubmit}>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="email">Room Name</Label>
                                <AvField
                                  type="text"
                                  value={this.state.roomName}
                                  onChange={this.handleChange}
                                  id="roomName"
                                  name="roomName"
                                  required
                                  errorMessage="Room name is required"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="roomType">RoomType</Label>
                                <Input
                                  type="select"
                                  name="roomType"
                                  id="roomType"
                                  value={this.state.roomType}
                                  onChange={this.handleChange}
                                  required
                                >
                                  <option>Select RoomType</option>
                                  {this.state.roomtypeData.map((e, key) => {
                                    return (
                                      <option key={key} value={e._id}>
                                        {e.type}
                                      </option>
                                    );
                                  })}
                                </Input>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="username">No. of Beds</Label>
                                <AvField
                                  type="number"
                                  min={1}
                                  value={this.state.beds}
                                  onChange={this.handleChange}
                                  id="beds"
                                  name="beds"
                                  required
                                  errorMessage="Number of beds is required"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="University">BedType</Label>
                                <AvField
                                  type="text"
                                  value={this.state.bedType}
                                  onChange={this.handleChange}
                                  id="bedType"
                                  name="bedType"
                                  required
                                  errorMessage="Bed type is required"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="username">BathroomType</Label>
                                <AvField
                                  type="text"
                                  value={this.state.bathroomType}
                                  onChange={this.handleChange}
                                  id="bathroomType"
                                  name="bathroomType"
                                  required
                                  errorMessage="Bathroom type is required"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="University">FoodAndBeverages</Label>
                                <AvField
                                  type="text"
                                  value={this.state.foodAndBeverages}
                                  onChange={this.handleChange}
                                  id="foodAndBeverages"
                                  name="foodAndBeverages"
                                  required
                                  errorMessage="Food and beverages are required"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="username">Bath</Label>
                                <AvField
                                  type="number"
                                  min={1}
                                  value={this.state.bath}
                                  onChange={this.handleChange}
                                  id="bath"
                                  name="bath"
                                  required
                                  errorMessage="Number of bathrooms is required"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="username">KitchenFeatures</Label>
                                <AvField
                                  type="text"
                                  value={this.state.kitchenFeatures}
                                  onChange={this.handleChange}
                                  id="kitchenFeatures"
                                  name="kitchenFeatures"
                                  required
                                  errorMessage="Kitchen features are required"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="University">Entertainment</Label>
                                <AvField
                                  type="text"
                                  value={this.state.entertainment}
                                  onChange={this.handleChange}
                                  id="entertainment"
                                  name="entertainment"
                                  required
                                  errorMessage="Entertainment is required"
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          {/* Guest-facing details. All optional: blank means
                              "not stated" and clears a saved value. */}
                          <Row form>
                            <Col md={12}>
                              <FormGroup>
                                <Label for="description">Description</Label>
                                <Input
                                  type="textarea"
                                  rows={3}
                                  value={this.state.description}
                                  onChange={this.handleChange}
                                  id="description"
                                  name="description"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="maxAdults">Max adults</Label>
                                <Input
                                  type="number"
                                  min={0}
                                  step={1}
                                  value={this.state.maxAdults}
                                  onChange={this.handleChange}
                                  id="maxAdults"
                                  name="maxAdults"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="maxChildren">Max children</Label>
                                <Input
                                  type="number"
                                  min={0}
                                  step={1}
                                  value={this.state.maxChildren}
                                  onChange={this.handleChange}
                                  id="maxChildren"
                                  name="maxChildren"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="sizeSqm">Size (m²)</Label>
                                <Input
                                  type="number"
                                  min={0}
                                  step="any"
                                  value={this.state.sizeSqm}
                                  onChange={this.handleChange}
                                  id="sizeSqm"
                                  name="sizeSqm"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={8}>
                              <FormGroup>
                                <Label for="cancellationPolicy">Cancellation policy</Label>
                                <Input
                                  type="textarea"
                                  rows={2}
                                  value={this.state.cancellationPolicy}
                                  onChange={this.handleChange}
                                  id="cancellationPolicy"
                                  name="cancellationPolicy"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="freeCancelHours">Free cancellation (hours)</Label>
                                <Input
                                  type="number"
                                  min={0}
                                  step={1}
                                  value={this.state.freeCancelHours}
                                  onChange={this.handleChange}
                                  id="freeCancelHours"
                                  name="freeCancelHours"
                                />
                                <small style={{ color: C.taupeLight }}>
                                  Blank uses the branch's policy
                                </small>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row form>
                            <Col md={6}>
                              <Label
                                htmlFor="example-number-input"
                                className="col-md-12 col-form-label"
                              >
                                RoomFurnitureAndFurnishing{" "}
                              </Label>

                              <div className="custom-file">
                                <AvField
                                  tag={CustomInput}
                                  name="file"
                                  id="file"
                                  type="file"
                                  accept="image/*"
                                  onChange={this.onFileChange}
                                  multiple
                                />
                                <Label
                                  className="custom-file-label"
                                  htmlFor="customFile"
                                >
                                  Choose file
                                </Label>
                              </div>
                              {(previewImage || []).map((url) => (
                                <img
                                  style={{
                                    borderRadius: "50%",
                                    width: 80,
                                    height: 80,
                                    // background: "red",
                                    display: "block",
                                  }}
                                  className="img-fluid"
                                  src={url}
                                  alt=""
                                />
                              ))}
                              <div>
                                {invalidImage && (
                                  <p className="error">{invalidImage}</p>
                                )}
                                <span> {this.state.selectedFileName}</span>
                                {handleResponse && (
                                  <p
                                    className={
                                      handleResponse.isSuccess ? "" : "error"
                                    }
                                  >
                                    {handleResponse.message}
                                  </p>
                                )}
                              </div>
                            </Col>

                            <Col md={6}>
                              <Label
                                htmlFor="example-number-input"
                                className="col-md-12 col-form-label"
                              >
                                Room Images{" "}
                              </Label>

                              <div className="custom-file">
                                <AvField
                                  tag={CustomInput}
                                  name="file"
                                  id="file"
                                  type="file"
                                  accept="image/*"
                                  onChange={this.onRoomFileChange}
                                  multiple
                                />
                                <Label
                                  className="custom-file-label"
                                  htmlFor="customFile"
                                >
                                  Choose file
                                </Label>
                              </div>
                              {(previewImageRoom || []).map((url) => (
                                <img
                                  style={{
                                    borderRadius: "50%",
                                    width: 80,
                                    height: 80,
                                    // background: "red",
                                    display: "block",
                                  }}
                                  className="img-fluid"
                                  src={url}
                                  alt=""
                                />
                              ))}

                              <div>
                                {invalidRoomImage && (
                                  <p className="error">{invalidRoomImage}</p>
                                )}
                                <span> {this.state.selectedFileName}</span>
                                {handleResponse && (
                                  <p
                                    className={
                                      handleResponse.isSuccess ? "" : "error"
                                    }
                                  >
                                    {handleResponse.message}
                                  </p>
                                )}
                              </div>
                            </Col>
                          </Row>

                          {/* <Row form>
<Col md={6}>
<Label htmlFor="example-number-input" className="col-md-12 col-form-label">Room Images </Label>

<div className="custom-file">
  
<AvField
              tag={CustomInput}
              name="file"
              id="file"
              type="file"
              accept="image/*"
              onChange={this.onRoomFileChange}
               
            />
<Label className="custom-file-label" htmlFor="customFile">Choose file</Label>
</div>    
{previewImageRoom && (
          <div>
            
            <img style={{
          borderRadius: "50%",
          width: 80,
          height: 80,
          // background: "red",
          display: "block"
        }} className="img-fluid" src={previewImageRoom}  alt="" />
          </div>
        )}
</Col>
</Row> */}
                          <div></div>
                          <Row style={{ marginTop: 16 }} form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="username">RoomFeatures</Label>

                                <Select
                                  className="dropdown"
                                  placeholder="Select Option"
                                  value={this.state.roomFeatures}
                                  onChange={this.handlefeatureChange}
                                  options={this.state.dropDownOpts} // set list of the data
                                  // assign onChange function

                                  isMulti
                                  isClearable
                                  // touchUi={false}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="University">
                                  HospitalityServices
                                </Label>
                                <Select
                                  className="dropdown"
                                  placeholder="Select Option"
                                  options={this.state.dropDownOpt} // set list of the data
                                  value={this.state.hospitalityServices}
                                  onChange={this.handlehospitalityChange} // assign onChange function
                                  isMulti
                                  isClearable
                                />
                                {/* <Input type="select" name="hospitalityServices" id="hospitalityServices" value={this.state.hospitalityServices} onChange={this.handleChange} required>
              <option>Select hospitalityServices</option>  
              {this.state.hospitalityServicesData.map((e, key) => {  
return <option key={key} value={e._id}>{e.hospitalityServiceName}</option>;  
})}  
        </Input> */}
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={6}>
                              <FormGroup
                                style={{ paddingLeft: 20, paddingTop: 40 }}
                              >
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    checked={this.state.availability}
                                    onChange={this.ShortlistedUser}
                                  />
                                  Availability
                                </Label>
                              </FormGroup>
                            </Col>
                          </Row>

                          <BranchAssignment
                            branchIds={this.state.branchIds}
                            excludedBranchIds={this.state.excludedBranchIds}
                            overrides={[]}
                            priceFields={[]}
                            onChange={({ branchIds, excludedBranchIds }) =>
                              this.setState({ branchIds, excludedBranchIds })
                            }
                          />

                          <div style={{ marginTop: 22, display: "flex", justifyContent: "flex-end", gap: 12 }}>
                            <Button
                              type="button"
                              color="link"
                              onClick={this.toggle}
                              style={{ color: C.taupe, textDecoration: "none" }}
                            >
                              Cancel
                            </Button>
                            <button type="submit" style={SUBMIT_STYLE}>
                              Submit
                            </button>
                          </div>
            </AvForm>
          </div>
        </Modal>

        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <StatRow>
            <StatCard icon="bed" value={rooms.length} label="Rooms on file" />
            <StatCard icon="check_circle" value={available} label="Available" />
            <StatCard icon="do_not_disturb_on" value={rooms.length - available} label="Not available" />
            <StatCard icon="category" value={this.state.roomtypeData.length} label="Room types" />
          </StatRow>

          <div style={{ display: "grid", gridTemplateColumns: "1.55fr 1fr", gap: 18, alignItems: "start" }}>
            <Panel style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  padding: "16px 22px", borderBottom: `1px solid ${C.panel}`,
                }}
              >
                <div style={{ fontSize: 17, fontWeight: 500, color: C.ink }}>Room inventory</div>
                <div style={{ fontSize: 13, color: C.taupeLight }}>
                  {rooms.length} room{rooms.length === 1 ? "" : "s"}
                </div>
              </div>
              <div style={{ padding: "0 10px" }}>
                <Table
                  columns={this.consoleColumns()}
                  rows={rooms}
                  empty={this.state.isLoaded ? "No rooms yet" : "Loading rooms…"}
                  onRowClick={(r) => this.setState({ selectedRoomId: r._id })}
                />
              </div>
            </Panel>

            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
              <Panel
                title={selected ? selected.roomName || "Room" : "Room preview"}
                subtitle={selected ? this.roomTypeName(selected) : "Select a room to see its detail"}
                actions={
                  selected && canWrite() ? (
                    <span
                      onClick={() => this.editRoom(selected._id.toString(), selected)}
                      style={{ fontSize: 14, color: C.brown, fontWeight: 500, cursor: "pointer" }}
                    >
                      Edit
                    </span>
                  ) : null
                }
              >
                {selected ? (
                  <React.Fragment>
                    <div style={{ marginTop: 14 }}>
                      <Thumb
                        key={selected._id}
                        src={this.roomImage(selected)}
                        fluid
                        height={150}
                        radius={14}
                      />
                    </div>
                    <div style={{ marginTop: 14, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                      {[
                        ["Beds", `${selected.beds || 0} · ${selected.bedType || "—"}`],
                        ["Bathrooms", `${selected.bath || 0} · ${selected.bathroomType || "—"}`],
                        ["Entertainment", selected.entertainment || "—"],
                        ["Kitchen", selected.kitchenFeatures || "—"],
                        [
                          "Guests",
                          selected.maxAdults == null && selected.maxChildren == null
                            ? "—"
                            : `${selected.maxAdults == null ? "—" : selected.maxAdults} adults · ${
                                selected.maxChildren == null ? "—" : selected.maxChildren
                              } children`,
                        ],
                        ["Size", selected.sizeSqm == null ? "—" : `${selected.sizeSqm} m²`],
                      ].map(([k, v]) => (
                        <div key={k} style={{ padding: "11px 13px", borderRadius: 12, background: C.surface }}>
                          <div style={{ fontSize: 12, color: C.taupeLight }}>{k}</div>
                          <div style={{ marginTop: 4, fontSize: 15, color: C.ink }}>{v}</div>
                        </div>
                      ))}
                    </div>
                  </React.Fragment>
                ) : (
                  <div style={{ marginTop: 14, fontSize: 14, color: C.taupeLight }}>
                    No rooms to preview yet.
                  </div>
                )}
              </Panel>

              <Panel title="Room types" subtitle="Rates come from the type, not the room">
                <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 11 }}>
                  {this.state.roomtypeData.length === 0 && (
                    <div style={{ fontSize: 14, color: C.taupeLight }}>No room types defined.</div>
                  )}
                  {this.state.roomtypeData.map((t) => (
                    <div
                      key={t._id}
                      style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 14, color: C.brownDeep }}
                    >
                      <span>{t.type}</span>
                      <span style={{ color: C.taupe }}>
                        ${Number(t.amount || 0).toLocaleString()} · {t.noOfRooms || 0} units
                      </span>
                    </div>
                  ))}
                </div>
                <div style={{ marginTop: 16 }}>
                  <Link to="/RoomType" style={{ fontSize: 14, color: C.brown, fontWeight: 500 }}>
                    Open room types →
                  </Link>
                </div>
              </Panel>
            </div>
          </div>
        </div>
      </ConsolePage>
    );
  }
}

export default FormMask;
